// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__rXsuP","heading":"firstFold_heading__UFv6G","subParagraph":"firstFold_subParagraph__E_SKz"};